var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-document"
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: false
        },
        on: {
          showEdit: _vm.initCurrentData,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.initCurrentData
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.hasFile
                    ? _c(
                        "div",
                        {
                          staticClass: "cw-pdf-header cw-block-title"
                        },
                        [
                          _c("button", {
                            staticClass: "cw-pdf-button-prev",
                            class: {
                              inactive: _vm.pageNum - 1 === 0
                            },
                            on: {
                              click: _vm.prevPage
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "cw-pdf-title"
                            },
                            [_vm._v(_vm._s(_vm.currentTitle))]
                          ),
                          _vm._v(" "),
                          _vm.fileDownloadable
                            ? _c("a", {
                                staticClass: "cw-pdf-download",
                                attrs: {
                                  href: _vm.currentUrl,
                                  download: ""
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _c(
                                "translate",
                                {
                                  attrs: {
                                    "translate-params": {
                                      pageNum: _vm.pageNum,
                                      pageCount: _vm.pageCount
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        (Seite %{ pageNum } von %{ pageCount })\n                    "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("button", {
                            staticClass: "cw-pdf-button-next",
                            class: {
                              inactive: _vm.pageNum === _vm.pageCount
                            },
                            on: {
                              click: _vm.nextPage
                            }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasFile
                    ? _c("canvas", {
                        ref: "pdfcanvas",
                        staticClass: "cw-pdf-canvas",
                        on: {
                          mousedown: function mousedown($event) {
                            _vm.browse = true
                          },
                          mouseup: function mouseup($event) {
                            _vm.browse = false
                          },
                          mouseleave: function mouseleave($event) {
                            _vm.browse = false
                          },
                          mousemove: _vm.browsePdf
                        }
                      })
                    : _vm._e()
                ]
              },
              proxy: true
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            }
                          }
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Überschrift")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentTitle,
                                    expression: "currentTitle"
                                  }
                                ],
                                attrs: {
                                  type: "text"
                                },
                                domProps: {
                                  value: _vm.currentTitle
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.currentTitle = $event.target.value
                                  }
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Datei")]),
                              _vm._v(" "),
                              _c("courseware-file-chooser", {
                                attrs: {
                                  isDocument: true
                                },
                                on: {
                                  selectFile: _vm.updateCurrentFile
                                },
                                model: {
                                  value: _vm.currentFileId,
                                  callback: function callback($$v) {
                                    _vm.currentFileId = $$v
                                  },
                                  expression: "currentFileId"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [
                                _vm._v("Download-Icon anzeigen")
                              ]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentDownloadable,
                                      expression: "currentDownloadable"
                                    }
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentDownloadable = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "true"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Ja")])],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "false"
                                      }
                                    },
                                    [_c("translate", [_vm._v("Nein")])],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Dateityp")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentDocType,
                                      expression: "currentDocType"
                                    }
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call($event.target.options, function(
                                          o
                                        ) {
                                          return o.selected
                                        })
                                        .map(function(o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.currentDocType = $event.target
                                        .multiple
                                        ? $$selectedVal
                                        : $$selectedVal[0]
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "pdf"
                                      }
                                    },
                                    [_vm._v("PDF")]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  },
                  proxy: true
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c(
                    "p",
                    [
                      _c("translate", [
                        _vm._v("Informationen zum Dokument-Block")
                      ])
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ],
          null,
          true
        )
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }